import api from './api';
import type { AccessLevel, Role } from '../types';

export const fetchRoles = () =>
  api.get<{ success: boolean; data: Role[] }>('/roles');

export const createRole = (data: { name: string; access?: Record<string, AccessLevel> }) =>
  api.post<{ success: boolean; data: Role }>('/roles', data);

export const updateRole = (id: string, data: { name?: string; access?: Record<string, AccessLevel> }) =>
  api.put<{ success: boolean; data: Role }>(`/roles/${id}`, data);

export const deleteRole = (id: string) =>
  api.delete<{ success: boolean }>(`/roles/${id}`);
